export enum IntroScreenEvent{
    ON_GET_STARTED_CLICKED = 'onGetStartedClicked'
}